import styled from "styled-components";
import {Button} from "antd";

export const AssignUserGroupButton = styled(Button)`
    margin-bottom: 10px;
`;
